import {
  store,
  getElement
} from '@wordpress/interactivity';

import { actions } from '@wordpress/interactivity-router';

const isEmpty = obj => [Object, Array].includes((obj || {}).constructor) && !Object.entries((obj || {})).length;
const searchDelay = 1000;

const updateURL = async (value, name) => {
  const url = new URL(window.location);

  const params = ['search'];


  if (params.includes(name)) {
    if (!isEmpty(value)) {
      url.searchParams.set(name, value);
    } else {
      url.searchParams.delete(name);
    }
  }

  await actions.navigate(`${window.location.pathname}${url.search}`);
};

const decodeHTMLEntities = (text) => {
  const textArea = document.createElement('textarea');
  textArea.innerHTML = text;
  return textArea.value;
};

const fetchPages = async (searchTerm) => {
  try {
    const response = await fetch(`${WLC?.rest_settings?.url}/ia-search?search=${searchTerm}&query_type=search`);

    //reset paged parameter when any new search is made
    state.resultsPage['post'] = 1;
    state.resultsPage['casino-online'] = 1;
    state.resultsPage['slots'] = 1;

    if (!response.ok) {
      console.error("Error while search request: ", response);
    }

    const results = await response.json();

    if (results.length === 0) {
      console.error("Error while search request: ", results);
      return [];
    }

    const posts = results?.posts?.map(item => ({
      id: item.id,
      post_title: decodeHTMLEntities(item.post_title),
      url: item.url,
      image_url: item.image_url,
    }));

    const all = results?.all?.map(item => ({
      id: item.id,
      post_title: decodeHTMLEntities(item.post_title),
      url: item.url,
    }));

    const casinos = results?.casinos?.map(item => ({
      id: item.id,
      post_title: decodeHTMLEntities(item.post_title),
      url: item.url,
      image_url: item.image_url,
      rating: item.rating
    }));

    const slots = results?.slots?.map(item => ({
      id: item.id,
      post_title: decodeHTMLEntities(item.post_title),
      url: item.url,
      image_url: item.image_url,
      rating: item.rating
    }));

    return {
      posts: posts,
      casinos: casinos,
      slots: slots,
      all: all,
      total_posts: results.total_posts,
      total_casinos: results.total_casinos,
      total_slots: results.total_slots,
    }

  } catch (error) {
    console.error('Error while results downloading: :', error);
    return [];
  }
};
const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

const hideInitialSearchResults = () => {
  const initialSearchResults = document.querySelectorAll('.search-results-listing');
  const resentSearches = document.querySelector('.instant-recent-searches');
  const popularSearches = document.querySelector('.popular-searches');

  if (!initialSearchResults) return;

  if (state?.matched_posts?.length || state?.matched_casinos?.length) {
    initialSearchResults.forEach(resultContainer => {
      resultContainer.classList.add('hidden');
    })
  } else if (state.search.length === 0) {
    initialSearchResults.forEach(resultContainer => {
      resultContainer.classList.remove('hidden');
    })
  }

  if(state.hasAnyResults && state.search.length > 0) {
    resentSearches.classList.add('hidden');
    popularSearches.classList.add('hidden');
  }
  else {
    resentSearches.classList.remove('hidden');
    popularSearches.classList.remove('hidden');
  }

}

const debouncedFetchPages = debounce(async (searchTerm, state, filterInputValue, paramType) => {


  if (searchTerm.length === 0) {
    state.matched_posts = [];
    state.matched_casinos = [];
    state.matched_slots = [];
    state.search = '';
    await updateURL(filterInputValue, paramType);
    state.hasAnyPosts = false;
    state.hasAnyCasinos = false;
    state.hasAnyResults = false;
    state.hasAnySlots = false;
    state.hasAnySuggestions = false;
    state.totalPages = 0;
    state.totalCasinos = 0;
    state.totalSlots = 0;
    state.hideMoreResults['post'] = true;
    state.hideMoreResults['casino-online'] = true;
    state.hideMoreResults['slots'] = true;
    hideInitialSearchResults();
    return;
  }

  await updateURL(filterInputValue, paramType);
  const results = await fetchPages(searchTerm);
  state.matched_posts = results.posts;
  state.matched_casinos = results.casinos;
  state.matched_slots = results.slots;
  state.matched_all = results.all;
  state.search = filterInputValue;
  state.hasAnyPosts = results.posts.length > 0;
  state.hasAnyCasinos = results.casinos.length > 0;
  state.hasAnySuggestions = results.all.length > 0;
  state.hasAnySlots = results.slots.length > 0;
  state.hasAnyResults = state.hasAnyPosts || state.hasAnyCasinos || state.hasAnySlots || state.matched_all.length;
  state.totalPosts = results.total_posts;
  state.totalCasinos = results.total_casinos;
  state.totalSlots = results.total_slots;
  state.hideMoreResults['post'] = state.totalPosts <= 3;
  state.hideMoreResults['casino-online'] = state.totalCasinos <= 3;
  state.hideMoreResults['slots'] = state.totalSlots <= 3;

  hideInitialSearchResults();

}, searchDelay);

const getInitialState = () => {

  const searchParams = new URLSearchParams(window.location.search);
  const search = searchParams.get('search') || '';

  return {
    search: search,
  };
};

const {state} = store('instantSearch', {
  state: getInitialState(),
  actions: {
    * updateSearch() {

      const {ref} = getElement();
      const {dataset} = ref;

      const searchInputValue = ref.value;
      const paramType = dataset.param;

      //if ('search' === paramType && searchInputValue === state.search) return;

      yield debouncedFetchPages(searchInputValue, state, searchInputValue, paramType);
    },

    * removeAllFilters() {
      const {actions} = yield import('@wordpress/interactivity-router');
      yield actions.navigate(`${window.location.pathname}`);
    },

    closeSearchContainer() {
      const container = document.querySelector('.search-results-wrapper');
      const instantSearchInput = document.querySelector('#instantSearch');
      const instantSearchBlock = document.querySelector('.instant-search');
      const headerTop = document.querySelector('.page-header__top');

      if (container) container.classList.remove('is-active');
      if (instantSearchInput) instantSearchInput.classList.remove('is-active');
      if (instantSearchBlock) instantSearchBlock.classList.remove('is-active');
      if (headerTop) headerTop.classList.remove('is-active-search');
    },

    openMobileInput() {
      const headerTop = document.querySelector('.page-header__top');

      if (!headerTop) return;

      headerTop.classList.add('is-active-search');
    },

    isActiveButton() {
      const {ref} = getElement();

      if (!ref) {
        return false;
      }

      const {dataset} = ref;
      const value = dataset.value;

      return state.pcat === value;
    },
    initSearch() {
      if (state.search.length > 0) {
        debouncedFetchPages(state.search, state, state.search, 'search');
      }
    }
  }
});